import React from 'react'

const SprocketButton = ({onComponentClick, text}) =>{
  return (
  <div className="sprocket-outer-container" onClick={onComponentClick}>
    <div className="sprocket-container">
      <div className="sprocket small spin reverse">
      </div>
      <div className="sprocket large spin">
      </div>
    </div>
    <div className="sprocket-text">{text}</div>
  </div>
  );
};

export default SprocketButton;
export { SprocketButton };